import { useEffect } from 'react'

const TAWK_SRC = 'https://embed.tawk.to/662442071ec1082f04e51a7a/1hruq3rt9'

declare global {
  interface Window {
    Tawk_API?: Record<string, unknown>
    Tawk_LoadStart?: Date
  }
}

export function useTawkTo(): void {
  useEffect(() => {
    if (document.querySelector(`script[src="${TAWK_SRC}"]`)) return

    window.Tawk_API = window.Tawk_API || {}
    window.Tawk_LoadStart = new Date()

    const script = document.createElement('script')
    script.async = true
    script.src = TAWK_SRC
    script.charset = 'UTF-8'
    script.setAttribute('crossorigin', '*')

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.body.appendChild(script)
    }
  }, [])
}
